import { useMemo } from "react";
import { format } from "date-fns";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves box number data.
 * @returns - A promise that resolves to the service data.
 */
export const useFetchService = () => {
  const memoizedFetchService = useMemo(
    () => async (date) => {
      const apiDate = format(date ? date : new Date(), "dd-MMM-yyyy");
      return apiGet(`/service/${apiDate}`, "fetching service");
    },
    []
  );

  return memoizedFetchService;
};
